/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SidebarDtoV2 } from '../models/sidebar-dto-v-2';

@Injectable({ providedIn: 'root' })
export class SideBarControllerService extends DataBaseService {

  /**
   * Path part for operation sideBarControllerGetViewsForSidebarV2
   */
  static readonly SideBarControllerGetViewsForSidebarV2Path = '/v2/side-bar';

  /**
   * Get all sidebar views (system and module)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getViewsForSidebarV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  getViewsForSidebarV2$Response(params?: {
    'x-domain-id'?: string;
    'x-space-id'?: string;
    include?: number;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<SidebarDtoV2>> {

    const rb = new RequestBuilder(this.rootUrl, SideBarControllerService.SideBarControllerGetViewsForSidebarV2Path, 'get');
    if (params) {
      rb.header('x-domain-id', params['x-domain-id'], {});
      rb.header('x-space-id', params['x-space-id'], {});
      rb.query('include', params.include, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SidebarDtoV2>;
      })
    );
  }
  /**
   * Get all sidebar views (system and module)
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getViewsForSidebarV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getViewsForSidebarV2(params?: {
    'x-domain-id'?: string;
    'x-space-id'?: string;
    include?: number;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<SidebarDtoV2> {

    return this.getViewsForSidebarV2$Response(params).pipe(
      map((r: StrictHttpResponse<SidebarDtoV2>) => r.body as SidebarDtoV2)
    );
  }

}
